@use "../../sass/variables/colors";
@use "../../sass/variables/dimensions";

.ux-number-input {
  display: block;
  position: relative;

  &__wrapper {
    align-items: stretch;
    border: 1px solid colors.$color-black;
    display: flex;
    flex-flow: row nowrap;
    height: var(--ux-input-height);
  }

  &__slot {
    display: none;
  }

  &__input[type="number"] {
    // hide spinner in number input
    -webkit-appearance: none;
    -moz-appearance: textfield;
    appearance: none;
    border: 1px solid colors.$color-black;
    border-bottom-width: 0;
    border-radius: 0;
    border-top-width: 0;
    font-family: var(--ux-font);
    font-size: var(--ux-input-font-size);
    font-weight: var(--ux-input-font-weight);
    height: 100%;

    // safari fix
    margin: 0;
    min-width: dimensions.$dim-45 + 2px;
    outline: none;
    padding: 13px dimensions.$dim-10;
    text-align: center;
    width: 100%;

    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      -webkit-appearance: none;
      appearance: none;
    }
  }

  &.ux-number-input--full-width {
    display: block;
  }

  &__btn {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background: colors.$color-gray-10;
    border: 0;
    border-radius: 0;
    cursor: pointer;
    flex: 0 0 auto;
    margin: 0;
    outline: 1px solid transparent;
    outline-offset: -1px;
    text-align: center;
    width: dimensions.$dim-45;

    &:focus-visible:not(:hover) {
      outline: 1px solid colors.$color-black-solid;
      outline-offset: -1px;
    }

    &:not(:active):hover {
      background: colors.$color-gray-10;
      border-color: colors.$color-gray-10;
      color: colors.$color-black-solid;
    }

    &:active,
    &:active:hover {
      background-color: #c5c5c5;
      border-color: #c5c5c5;
      box-shadow: none;
      color: colors.$color-black-solid;
    }

    &--disabled {
      background: colors.$color-white;
      font-size: 0;
      pointer-events: none;
    }
  }

  .ux-form-group--error &,
  &--error {
    .ux-number-input__wrapper {
      border-color: colors.$color-red-error;
    }

    .ux-number-input__input[type="number"] {
      border-color: colors.$color-red-error;
      color: colors.$color-red-error;
    }

    .ux-number-input__btn {
      color: colors.$color-red-error;
    }
  }

  .ux-form-group--disabled &,
  &--disabled {
    pointer-events: none;

    .ux-number-input__wrapper {
      opacity: var(--ux-input-disabled-opacity);
    }
  }
}

.ux-number-input:not(.ux-number-input--full-width) {
  @media (min-width: 768px) {
    display: inline-block;

    .ux-number-input__wrapper,
    .ux-number-input__input {
      display: inline-flex;
    }
  }

  .ux-number-input__wrapper,
  .ux-number-input__input {
    .ux-form-group & {
      display: inline-flex;
    }
  }
}
